<template lang="pug">
  b-container
    .header.mb-2.mt-0
      .header-body
        h6.header-pretitle
          | Configuración de {{account.name || 'la cuenta'}}
    b-row
      b-col.d-flex.flex-column.align-items-center.justify-content-start.mb-3(cols="12", md="auto")
        label.text-secondary Imagen de cuenta
        Avatar.pointer.mb-2(size="xl", :src="account.image", @click="$refs.input_image.click()", v-b-tooltip.hover, :title="account.image ? 'Cambiar imagen' : 'Subir imagen'")
        b-link.text-danger.text-sm.mb-4(v-if="account.image", @click="$store.commit('account/updateAccountAttribute', {attribute: 'image', value: ''})") Quitar imagen
        b-link.text-primary.text-sm.mb-4(v-else, @click="$refs.input_image.click()") Subir imagen
        label.text-secondary Imagen de chatbot
        Avatar.pointer.mb-2(size="lg", :src="account.bot_image", @click="$refs.input_bot_image.click()", v-b-tooltip.hover, :title="account.bot_image ? 'Cambiar imagen' : 'Subir imagen'")
        b-link.text-danger.text-sm(v-if="account.bot_image", @click="$store.commit('account/updateAccountAttribute', {attribute: 'bot_image', value: ''})") Quitar imagen
        b-link.text-primary.text-sm(v-else, @click="$refs.input_bot_image.click()") Subir imagen
      b-col
        b-card
          h6 Información del representante de la cuenta
          b-form.mt-3
            b-form-group
              label.text-secondary Nombre del representante
              b-form-input(v-model.trim="account.representative_name", placeholder="Nombre", :state="account.representative_name ? null : (validated ? false : null)")
            b-form-group
              label.text-secondary Email
              b-form-input(v-model.trim="account.email", placeholder="Email", :state="account.email ? null : (validated ? false : null)")
            b-form-group
              label.text-secondary Teléfono
              b-form-input(v-model.trim="account.phone", placeholder="Teléfono", :state="account.phone ? null : (validated ? false : null)")
            b-form-group
              label.text-secondary Giro del negocio
              b-form-input(v-model.trim="account.business_turn", placeholder="Giro", :state="account.business_turn ? null : (validated ? false : null)")

        b-button.mb-3(variant="primary", block, @click="updateAccount") Guardar cambios
    input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected($event, 'image')")
    input(type="file", accept="image/*", style="display:none;", ref="input_bot_image", @change="imageSelected($event, 'bot_image')")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import Avatar from '../../components/Avatar.vue'
import { UploadFile } from '../../helpers/upload-file'
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      file_image: null,
      file_bot_image: null,
      validated: false
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account,
    }),
  },
  methods: {
    ...mapActions(['account/update', 'helpers/upload_file']),
    async updateAccount () {
      let self = this

      if(!this.account.representative_name || !this.account.email || !this.account.phone || !this.account.business_turn) {
        this.validated = true
        return
      }

      if (this.file_image) {
        try {
          let new_image = await UploadFile.call(this, this.file_image)
          this.$store.commit('account/updateAccountAttribute', {attribute: 'image', value: new_image})
          this.file_image = null
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      if (this.file_bot_image) {
        try {
          let new_bot_image = await UploadFile.call(this, this.file_bot_image)
          this.$store.commit('account/updateAccountAttribute', {attribute: 'bot_image', value: new_bot_image})
          this.file_bot_image = null
        } catch (e) {
          this.$message.error(e.message)
        }
      }

      this['account/update']({
        ...self.account,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Cuenta actualizada.')
          }
        }
      })
    },
    imageSelected(event, key) {
      let files = event.target.files

      if(files.length) {
        let file = files[0]
        try {
          this.$store.commit('account/updateAccountAttribute', {attribute: key, value: URL.createObjectURL(file)})
          this['file_' + key] = file
        } catch (e) {
          this.$message.warning('No logramos crear la vista previa de la imagen, por favor comprueba tu conexión a internet')
        }
      }
      this.$refs['input_' + key].value = ''
    },
  },
  mounted () {
  },
  components: {Avatar}
}
</script>

<style lang="scss" scoped>
</style>
